module.exports = { 
    _id: null,
    _instance: null,
    _now: null,
    _dimensions: {
        'dimension1':'company',
        'dimension2':'team',
        'dimension3':'user', 
        'dimension4':'page', 
        'dimension5':'template',
        'dimension6':'member',
        'dimension7':'engagement'
    },
    initialized() {
        if (!this._instance || !this._id || !this._now) {
            console.log('Analytics not initialized!')
            return false
        }
        return true
    },
    init(id) {
        if (!window.pfpanalytics) {
            console.log('Google analytics not loaded!')
            return
        }
        this._instance = window.pfpanalytics
        this._id = id
        this._now = new Date()
        this._instance('config', this._id, {'custom_map': this._dimensions})
    },
    path(path) {
        if (this.initialized()) {
            if (path == '/dashboard') {
                this._instance('config', 'AW-869441345')
            }
            this._instance('config', this._id, {'page_path': path, 'custom_map': this._dimensions})
        }
    },
    set(company, team, user) {
        if (this.initialized()) {
            this._instance('event', 'set_user', {'company': company, 'team': team, 'user': user})
        }
    },
    enter(page) {
        if (this.initialized()) {
            this._instance('event', 'navigate_to', {'page': page})
        }
    },
    track(event) {
        if (this.initialized()) {
            if (event == 'signup') {
                this._instance('event', 'conversion', {'send_to': 'AW-869441345/sLHSCNH3rNoBEMG-yp4D'})
            }
            if (event == 'trial') {
                this._instance('event', 'conversion', {'send_to': 'AW-869441345/HIifCNyl290BEMG-yp4D'})
            }
        }
    },
    leave(engagement, template, category, page, label) {
        if (this.initialized()) {
            let time = this._now.getTime()
            this._now = new Date()
            this._instance('event', 'timing_complete', {
                'name': label,
                'value': parseInt(this._now.getTime() - time),
                'event_category': category,
                'event_label': 'navigate_from',
                'engagement': engagement,
                'template': template,
                'page': page,
            })
        }
    }
}
